import { DiagnocoinLedgerEntry } from '@/shared/api/protocol-ts/api/billing_new/dto_diagnocoin_new_pb';

export const getAvailableDelta = (entry: DiagnocoinLedgerEntry): number =>
  Number(entry.Deltas?.Available ?? 0);
